<template>
<div class="content-body tenant-settings">
    <!-- <div class="" style="background: red ;display: none"> -->
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
            <el-form-item label="项目编码:">
                <el-input size="small" v-model="dataForm.projectCode" placeholder="项目编码" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="项目名称:">
                <el-input size="small" v-model="dataForm.projectName" placeholder="项目名称" clearable @blur="getDataList"></el-input>
            </el-form-item>

            <el-form-item label="车型:">
                <el-input size="small" v-model="dataForm.carType" placeholder="车型" clearable @blur="getDataList"></el-input>
            </el-form-item>

            <el-form-item label="项目状态:">
                <el-select size="small" v-model="dataForm.projectStatus" placeholder="请选择项目状态" clearable @change="getDataList">
                    <el-option v-for="item in PROJECT_STATUS" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="small" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
                <el-button size="small" v-if="isAuth('sourcing:project:newbutton')" type="primary" plain @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建项目
                </el-button>
                <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-upload2">
                    导入项目
                </el-button> -->
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :header-cell-style="{background:'#f5f5f5'}" border :data="dataList" row-key="id" size="mini" style="width: 100%;" :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="projectCode" header-align="center" align="left" label="项目编码"  width="150">
                </el-table-column>
                <el-table-column prop="projectName" header-align="center" align="left" label="项目名称" width="150">
                </el-table-column>
                <el-table-column prop="carType" header-align="center" align="left" label="车型信息" width="150">
                </el-table-column>
                <el-table-column prop="projectStatus" header-align="center" align="center" label="项目状态" width="70">
                    <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.projectStatus)">
                            {{projectStatusFormat(scope.row.projectStatus)}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="projectManagerName" header-align="center" align="left" label="采购项目工程师" width="120">
                </el-table-column>
                <el-table-column prop="supplyResponsor" header-align="center" align="left" label="采购负责人" width="120">
                </el-table-column>
                <el-table-column prop="techResponsor" header-align="center" align="left" label="项目总监" width="120">
                </el-table-column>
                <el-table-column prop="qualityResponsor" header-align="center" align="left" label="质量负责人" width="120">
                </el-table-column>
                <el-table-column prop="createProjectTime" header-align="center" align="left" label="项目创建时间" :formatter="dateFormat" width="150">
                </el-table-column>
                <el-table-column header-align="center" align="left" width="190" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row)" :disabled="judgeTechnicalStatus(scope.row.projectStatus)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" :disabled="judgeTechnicalStatus(scope.row.projectStatus)" icon="el-icon-delete" :class="{'button-danger':isActive}">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
</div>
</template>

<script>
import {
    projectList,
    deleteProject,
    // list
} from '@/controller/project'
import {
    PROJECT_STATUS,
    getLabelByValue
} from '@/utils/const'
import AddOrUpdate from './project-add-or-update'
import moment from 'moment'
export default {
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
                projectCode: '',
                projectName: '',
                carType: '',
                projectStatus: '',
                projectManagerName: '',
                createProjectTime: ''
            },
            PROJECT_STATUS: PROJECT_STATUS,
            getLabelByValue: getLabelByValue,
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false
        }
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 220
            }
        }
    },

    components: {
        AddOrUpdate
    },
    activated() {
        this.getDataList()
    },
    methods: {
        judgeTechnicalStatus(val) {
            if (val === '0') {
                this.isActive = true
                return false
            } else {
                this.isActive = false
                return true
            }
        },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        projectStatusFormat: function (value) {
            if (!value) {
                return ''
            }
            return getLabelByValue(PROJECT_STATUS, value)
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            projectList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                'projectCode': this.dataForm.projectCode,
                'projectName': this.dataForm.projectName,
                'carType': this.dataForm.carType,
                'projectStatus': this.dataForm.projectStatus,
                'projectManagerName': this.dataForm.projectManagerName,
                'createProjectTime': this.dataForm.createProjectTime
            }).then(data => {
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 查看
        viewHandle(row) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'view')
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'edit')
            })
        },
        // 删除
        deleteHandle(id) {
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteProject({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        //动态控制class,修改项目状态文字颜色
        getStatusClass(status) {
            let className = ''
            switch (status) {
                case '0':
                    className = "text-primary"
                    break;
                default:
                    className = 'text-success'
                    break;
            }
            return className
        }
    }
}
</script>
